import { Matrix } from 'app/models/questions/Matrix'
import { QuestionComponent } from 'app/models/questions/QuestionComponent'
import { NameComponent } from 'app/modules/survey/survey-viewer/survey-question/types/name/name.component'
import { UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms'
import { requireCommentOnOpenSelection } from 'app/form-validators/RequireCommentOnOpenSelectionValidator'
import { LoremIpsum } from 'lorem-ipsum'

export class Name extends Matrix {

  private readonly _firstNameControlName = 'info_firstname'
  private readonly _lastNameControlName = 'info_lastname'

  getDisplayComponent(): QuestionComponent {
    return new QuestionComponent(NameComponent, this)
  }

  buildQuestionFormGroup(): UntypedFormGroup {
    const formGroup = new UntypedFormGroup({})

    this.rowsOrder.forEach(rKey => {
      const validators = this.isOptional ? [] : [requireCommentOnOpenSelection(this.formControlName, this.commentsControlName, this.getOpenStatementsForRow(rKey))]
      const statementFormGroup = new UntypedFormGroup({
        [this.formControlName]: this.buildNameStatementFormGroup(),
        [this.commentsControlName]: this.buildNameCommentFormGroup()
      }, validators)
      formGroup.addControl(rKey, statementFormGroup)
    })

    return formGroup
  }

  fillFormWithDummyAnswer(surveyForm) {
    this.resetForm(surveyForm)

    this.setEverySelectedControlToTrueForGivenRow(surveyForm, this.rowKeys[this.rowKeys.length - 1])
    this.buildRandomValidAnswer(surveyForm)
  }

  private buildNameStatementFormGroup(): UntypedFormGroup {
    const form = new UntypedFormGroup({})
    this.statementKeys.forEach(sKey => {
      form.addControl(sKey, new UntypedFormControl(true))
    })
    return form
  }

  private buildNameCommentFormGroup() {
    const form = new UntypedFormGroup({})
    this.statementKeys.forEach(sKey => {
      const validators = this.addValidators()
      form.addControl(sKey, new UntypedFormControl('', {validators}))
    })
    return form
  }

  private addValidators(): ValidatorFn[] {
    const validators = []
    if (this.isOptional) {
      return validators
    }
    return [Validators.required]
  }

  private buildRandomValidAnswer(surveyForm) {
    const dummyValueMapping = {
      [this.firstNameControlName]: new LoremIpsum().generateWords(1),
      [this.lastNameControlName]: new LoremIpsum().generateWords(1),
    }

    this.statementKeys.forEach(sKey => {
      surveyForm.controls[this.key].get(this.rowKeys.pop()).get(this.commentsControlName).get(sKey).setValue(dummyValueMapping[sKey], {emitEvent: false})
    })
  }

  get firstNameControlName() {
    return this._firstNameControlName
  }

  get lastNameControlName() {
    return this._lastNameControlName
  }
}
